import { WalletLinkConnector } from "@web3-react/walletlink-connector";

export const makeWalletLinkConnector = (rpc: string) => new WalletLinkConnector({
  appName: 'Liquity.app',
  url: rpc
});